"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadCarmineImportTemplate = downloadCarmineImportTemplate;
exports.downloadKami = downloadKami;
exports.getCardDetailList = getCardDetailList;
exports.getPlatFormList = getPlatFormList;
exports.getProductSkuList = getProductSkuList;
exports.importBindCard = importBindCard;
exports.kamiDetailLists = kamiDetailLists;
exports.removeKami = removeKami;
exports.saveCardConfig = saveCardConfig;
exports.updateCard = updateCard;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getPlatFormList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // return request({
  //     url: '/admin/platform/card/list',
  //     method: 'post',
  //     data
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/payment/admin/platformCarmine/list',
    method: 'post',
    data: data
  });
}
function getProductSkuList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // return request({
  //     url: '/admin/store/sku/list',
  //     method: 'GET',
  //     params
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/store/sku/list',
    method: 'GET',
    params: params
  });
}
function updateCard() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // return request({
  //     url: '/admin/platform/card/carmine/save',
  //     method: 'post',
  //     data
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/payment/admin/platformCarmine/carmine/save',
    method: 'post',
    data: data
  });
}
function getCardDetailList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // return request({
  //     url: '/admin/platform/card/carmine/list',
  //     method: 'GET',
  //     params
  // });
  // 历史后端是POST提交，GET会报错，这里改为POST

  return (0, _requestMapi.default)({
    url: '/mapi/payment/admin/platformCarmine/carmine/list',
    method: 'POST',
    params: params
  });
}
function importBindCard(data, skuId) {
  return (0, _requestMapi.default)({
    url: '/mapi/payment/admin/platformCarmine/carmine/import-bind',
    method: 'post',
    params: {
      skuId: skuId
    },
    data: data
  });
}
function downloadCarmineImportTemplate() {
  return (0, _request.default)({
    url: '/admin/export/excel/template',
    method: 'get',
    params: {
      fileName: 'platform_card_carmine_import_template.xlsx'
    }
  });
}
function downloadKami(params) {
  return (0, _request.default)({
    url: '/admin/platform/card/carmine/download',
    method: 'post',
    params: params
  });
}
function kamiDetailLists(data) {
  // return request({
  //     url: `/admin/platform/card/carmine/list`,
  //     method: 'post',
  //     data,
  // });

  return (0, _requestMapi.default)({
    url: '/mapi/payment/admin/platformCarmine/carmine/list',
    method: 'post',
    data: data
  });
}
function removeKami(data) {
  // return request({
  //     url: `/admin/platform/card/carmine/remove`,
  //     method: 'post',
  //     data,
  // });
  return (0, _requestMapi.default)({
    url: "/mapi/payment/admin/platformCarmine/carmine/remove",
    method: 'post',
    data: data
  });
}
function saveCardConfig() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // return request({
  //     url: '/admin/platform/card/config/save',
  //     method: 'post',
  //     data
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/payment/admin/platformCarmine/config/save',
    method: 'post',
    data: data
  });
}